// Helpers for click-to-WhatsApp using wa.me links (no API).
// Pakistan mobile numbers are normalized to country code 92.

export function normalizePkMobile(raw) {
  if (!raw) return "";
  const digits = String(raw).replace(/\D/g, "");
  if (!digits) return "";
  // 03001234567 → 923001234567
  if (digits.startsWith("0") && digits.length === 11) return "92" + digits.slice(1);
  // 3001234567 → 923001234567 (already without leading 0)
  if (digits.length === 10 && digits.startsWith("3")) return "92" + digits;
  // 923001234567 already
  if (digits.startsWith("92")) return digits;
  // +92... was stripped to 92...; otherwise return as-is and hope for the best
  return digits;
}

export function renderTemplate(template, ctx) {
  if (!template) return "";
  let out = template;
  for (const [k, v] of Object.entries(ctx || {})) {
    out = out.split("{{" + k + "}}").join(String(v ?? ""));
  }
  return out;
}

export function buildWaLink(mobile, message) {
  const num = normalizePkMobile(mobile);
  const text = encodeURIComponent(message || "");
  if (!num) return null;
  return `https://wa.me/${num}?text=${text}`;
}

export function pickBucket(loan) {
  if (!loan) return "before_due";
  if (loan.current_status === "overdue" || loan.status === "overdue") return "overdue";
  const nd = loan.next_due;
  if (!nd?.due_date) return "before_due";
  const diffDays = Math.floor((new Date(nd.due_date).getTime() - Date.now()) / 86400000);
  if (diffDays === 0) return "due_today";
  if (diffDays < 0) return "overdue";
  return "before_due";
}

export function fmtPKRPlain(n) {
  return new Intl.NumberFormat("en-PK", { maximumFractionDigits: 0 }).format(Number(n || 0));
}
